import React, {useState, useEffect} from 'react'
import BookVendorAppointment from './BookVendorAppointment'
import {VendorServiceTypeCleaning} from '../../Services/ServicesConstants'
import Routes from '../../../constants/RouteConstants'
import {FormComponentPropTypes} from '../onboardingTypes'

function BookCleaning(props) {
  return <BookVendorAppointment {...props} serviceType={VendorServiceTypeCleaning} viewSingleRoute={Routes.CLEANING_VIEW_SINGLE} />
}

export default BookCleaning

BookCleaning.propTypes = FormComponentPropTypes
